module.exports = __webpack_public_path__ + "img/30.59b5a138.jpg";